var _Path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { Path } from "react-native-svg";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _Path || (_Path = /*#__PURE__*/React.createElement(Path, {
    fill: "#fff",
    d: "M22 11.066C22 4.955 17.075 0 11 0S0 4.955 0 11.068C0 16.57 3.99 21.134 9.218 21.99L9.28 22v-7.733H6.487v-3.2h2.794V8.628a4 4 0 0 1-.022-.41c0-2.158 1.739-3.907 3.883-3.907q.155 0 .308.012l-.013-.001c.88.012 1.73.09 2.56.23L15.9 4.54v2.723h-1.388a1.595 1.595 0 0 0-1.793 1.735v-.006 2.075h3.05l-.487 3.2h-2.563V22A11.07 11.07 0 0 0 22 11.066"
  })));
};
export default SvgFacebook;